var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 1.763a1.4 1.4 0 011.4 0l4.35 2.512c.434.25.7.712.7 1.212v5.024c0 .5-.266.963-.7 1.213L8.7 14.236a1.4 1.4 0 01-1.4 0l-4.35-2.512a1.4 1.4 0 01-.7-1.213V5.487c0-.5.266-.962.7-1.212L7.3 1.763z",
    stroke: "#626E85",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1.806,
    stroke: "#626E85",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/template-group-manage.becf0b71.svg";
export { SvgTemplateGroupManage as ReactComponent };